// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DocumentPagingResultModel from '../../model/document-paging-result-model';
import DocumentPagingResultDTO from '../dto/document-paging-result-dto';
import DocumentModel from '../../model/document-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class DocumentPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DocumentPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => DocumentModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  'items'?: DocumentModel[];
  /**
  */
  'links'?: ResourceLinkModel[];
  /**
  */
  'paginationData'?: PaginationDataModel;

  static toModel(dto: DeepPartial<DocumentPagingResultDTO>): DocumentPagingResultModel;
  static toModel(dto: DeepPartial<DocumentPagingResultDTO> | undefined | null): DocumentPagingResultModel | undefined;
  static toModel(dto: DeepPartial<DocumentPagingResultDTO> | undefined | null): DocumentPagingResultModel | undefined {
    return dto ? new DocumentPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DocumentPagingResultModel> | DocumentPagingResultModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'items': unwrapped.items,
      'links': unwrapped.links,
      'paginationData': unwrapped.paginationData,
    } as DocumentPagingResultDTO;
  }
}
